// extracted by mini-css-extract-plugin
module.exports = {"about":"about_about__3JvHw","about_right":"about_about_right__Oanvu","about_left":"about_about_left__3j2SX"};